import axios from "axios";
import { auth } from "../config";

const apiClient = axios.create({
  baseURL: process.env.REACT_APP_baseUrl,
  headers: {
    "Content-Type": "application/json",
  },
});

apiClient.interceptors.request.use(async (config) => {
  const user = auth.currentUser;
  if (user) {
    // Force-refresh the ID token when email is verified so the server
    // receives the updated email_verified claim (cached tokens lag behind).
    const token = await user.getIdToken(!!user.emailVerified);
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export async function getAuthHeaders() {
  const user = auth.currentUser;
  if (!user) {
    return { "Content-Type": "application/json" };
  }
  const token = await user.getIdToken(!!user.emailVerified);
  return {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };
}

export default apiClient;
